import Checkbox from "@mui/material/Checkbox";
import UsersActionMenu from "./usersActionsMenu";

function getTableData(users, setIsEditingUser, setUserToEdit) {
  //   return list of [    {
  //     "id": 145693,
  //     "email": "sguevara@farcovetsa.com",
  //     "name": "Stephanie",
  //     "lastName": "Guevara",
  //     "active": 1,
  //     "company": {
  //         "id": 133577,
  //         "code": "FARC",
  //         "name": "FARCOVET",
  //         "representative": "Franklin Íñiguez",
  //         "telephone": "(04) 606-0800"
  //     },
  //     "companyId": 133577,
  //     "roles": [
  //         {
  //             "id": 3,
  //             "role": "REPORT",
  //             "description": "Reportes"
  //         },
  //         {
  //             "id": 2,
  //             "role": "USER",
  //             "description": "Usuario"
  //         }
  //     ],
  //     "tokenAutentication": "5356"
  // }]
  let _rows = [];
  users.forEach((element, index) => {
    const row = {
      Nro: index + 1,
      Email: element.email,
      Nombre: element.name,
      Apellidos: element.lastName,
      Empresa: element.company.name,
     Roles: Array.isArray(element.roles) && element.roles.length > 0
  ? element.roles
      .filter(r => r && r.description)
      .map(r => r.description)
      .join(', ')
  : 'Sin roles',
      Activo: <Checkbox checked={element.active === 1}></Checkbox>,
      Acciones: (
        <UsersActionMenu
          setIsEditingUsers={setIsEditingUser}
          element={element}
          setElementToEdit={setUserToEdit}
        ></UsersActionMenu>
      ),
    };
    _rows.push(row);
  });

  return {
    columns: [
      { Header: "Nro", accessor: "Nro", width: "5%" },
      { Header: "Email", accessor: "Email" },
      { Header: "Nombre", accessor: "Nombre" },
      { Header: "Apellidos", accessor: "Apellidos" },
      { Header: "Empresa", accessor: "Empresa" },
      { Header: "Roles", accessor: "Roles" },
      { Header: "Activo", accessor: "Activo" },
      { Header: "Acciones", accessor: "Acciones", width: "6%" },
    ],
    rows: _rows,
  };
}

export default getTableData;
